import { MonitorIcon } from 'lucide-react';
import { Node } from '@xyflow/react';
import { EventCatalogResource, View as ViewType } from '../../types';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

type ViewNodeData = EventCatalogResource & {
  view: ViewType;
};

export type ViewNode = Node<ViewNodeData, 'view'>;

export default function View(props: ViewNode) {
  const { data, selected } = props;
  const { 
    name, 
    summary,
    screenshot 
  } = props.data.view;

  const mode = props.data.mode || 'simple';

  const nodeLabel = 'View';

  return (
    <div className={classNames(
        "w-full rounded-md border flex justify-start bg-white text-black min-h-[100px]",
        selected ? "border-blue-600 ring-2 ring-blue-500 shadow-lg" : "border-blue-400"
      )}>
        <div
          className={`bg-gradient-to-b from-blue-500 to-blue-700 relative flex items-center w-5 justify-center rounded-l-sm text-blue-100 border-r-[1px] border-blue-500`}
        >
          <MonitorIcon className="w-4 h-4 opacity-90 text-white absolute top-1" />
          {mode === 'full' && (
            <span
              className={"w-1/2 text-center absolute bottom-1 text-[8px] text-white font-bold uppercase tracking-[3px]"}
              style={{ transform: 'rotate(-90deg)' }}
            >
              {nodeLabel}
            </span>
          )}
        </div>
        <div className="p-1 min-w-60 max-w-[min-content]">
          <div className="pb-1">
            <span className="text-xs font-bold block pt-0.5 pb-0.5">{name}</span>
            {mode === 'simple' && (
              <span className="text-[10px] text-gray-500 font-light block pt-0.5 pb-0.5">{nodeLabel}</span>
            )}
          </div>
          {summary && (
            <div className="pb-1">
              <span className="text-[8px] font-light text-gray-600 block leading-tight">{summary}</span>
            </div>
          )}
          {screenshot && (
            <div className="py-1">
              <img 
                src={screenshot} 
                alt={`${name} screenshot`}
                className="w-full max-w-40 h-20 object-cover rounded border border-gray-200"
              />
            </div>
          )}
        </div>
    </div>
  );
}